module.exports = __webpack_public_path__ + "img/apple-podcasts.3b621d9b.png";